import { NetworkStatus } from '@apollo/client';
import { useEffect, useMemo, useState } from 'react';

import { User } from '@/core/graphql/generated/types';
import { useIdToken, useSetCurrentUser } from '@/core/store/auth/authSelectors';

import { useGetCurrentUserLazyQuery } from '../_graphql/query/GetCurrentUser.hook';

export const useFetchCurrentUser = () => {
	const [initialLoading, setInitialLoading] = useState(true);
	const [getCurrentUser, { data, networkStatus }] =
		useGetCurrentUserLazyQuery();
	const setCurrentUser = useSetCurrentUser();
	const idToken = useIdToken();

	useEffect(() => {
		const fetchUser = async () => {
			await getCurrentUser();
			setInitialLoading(false);
		};

		if (idToken) {
			fetchUser();
		}
	}, [idToken, getCurrentUser]);

	const user = useMemo(
		() =>
			data?.currentUser.__typename === 'User'
				? (data.currentUser as User)
				: null,
		[data?.currentUser]
	);

	const loading = useMemo(
		() => initialLoading || networkStatus === NetworkStatus.loading,
		[initialLoading, networkStatus]
	);

	useEffect(() => {
		if (user) {
			setCurrentUser(user);
		}
	}, [user, setCurrentUser]);

	return {
		loading
	};
};
